import Amplify from '@aws-amplify/core';

export default name => {
    return new Amplify.Logger(`:::${name}:::`);
};